module.exports = __webpack_public_path__ + "img/file-excel.c4402951.svg";